import { isHttpError } from "~/utils/httpClient";

export const mapToUserError = (error: Error | unknown): string => {
  if (isHttpError(error)) {
    const data = error.response?.data;
    if (
      typeof data === "object" &&
      data !== null &&
      "message" in data &&
      typeof data.message === "string"
    )
      return data.message;
  }
  return "Something went wrong";
};
